'use client';

import { useEffect } from 'react';

type AnalyticsWindow = Window & {
  clarity?: ((...args: unknown[]) => void) & { q?: unknown[][] };
};

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart'] as const;

export function AnalyticsLoader() {
  useEffect(() => {
    const analyticsWindow = window as AnalyticsWindow;

    const loadClarity = () => {
      INTERACTION_EVENTS.forEach((eventName) =>
        window.removeEventListener(eventName, loadClarity)
      );

      const clarity = ((...args: unknown[]) => {
        clarity.q = clarity.q ?? [];
        clarity.q.push(args);
      }) as NonNullable<AnalyticsWindow['clarity']>;
      analyticsWindow.clarity = clarity;
      clarity('consentv2', {
        ad_Storage: 'denied',
        analytics_Storage: 'denied',
      });

      const clarityTag = document.createElement('script');
      clarityTag.async = true;
      clarityTag.src = 'https://www.clarity.ms/tag/y7cg52epkd';
      document.head.appendChild(clarityTag);
    };

    INTERACTION_EVENTS.forEach((eventName) =>
      window.addEventListener(eventName, loadClarity, {
        once: true,
        passive: true,
      })
    );

    return () => {
      INTERACTION_EVENTS.forEach((eventName) =>
        window.removeEventListener(eventName, loadClarity)
      );
    };
  }, []);

  return null;
}
